import * as React from 'react';
import { SVGProps } from 'react';

const IconJiraSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.51 2H7.868c0 .678.269 1.328.747 1.807.477.48 1.125.748 1.8.748h1.04v1.007c.001 1.41 1.14 2.553 2.546 2.554V2.49A.49.49 0 0 0 13.51 2Z" />
    <path d="M10.584 4.956H4.941c0 1.41 1.14 2.553 2.546 2.554h1.04v1.01a2.551 2.551 0 0 0 2.547 2.552V5.447a.49.49 0 0 0-.49-.491Z" />
    <path d="M7.643 7.884H2a2.551 2.551 0 0 0 2.547 2.556H5.59v1.006A2.551 2.551 0 0 0 8.133 14V8.375a.49.49 0 0 0-.49-.49Z" />
  </svg>
);
export default IconJiraSizeS;
